import React,{useState} from 'react'
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import { isMobile } from 'react-device-detect';
import { modalToggle } from 'redux/actions/general';
import { useDispatch,useSelector } from 'react-redux';
import './style.css'
import Logo from 'assets/image/logo-qubisa.png'
import Trolli from 'assets/icon/Trolli.png'
import Cookie from 'universal-cookie'
import DefaultAva from 'assets/icon/default-ava.jpeg'
import { logout } from 'redux/actions/auth';
import { setPersist } from 'redux/actions/persist';
const cookie=new Cookie()
const profile=cookie.get('profile_cookie_forum')
const token=cookie.get('login_cookie_forum')

const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
      padding:0,
      backgroundColor: 'white',
      color: 'rgba(0, 0, 0, 0.87)',
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #dadde9',
      boxShadow: 'solid 0.5px #cccccc',
    },
    arrow: {
        "&:before": {
          border: '1px solid #dadde9',
          backgroundColor: "white",
        },
      },
  }))(Tooltip);
 
function Navbar({bgcolor,router}) {
    const dispatch = useDispatch()
    const persist = useSelector(state => state.persist)
    // console.log(`profile`, profile)
    let {is_auth_qubisa}=persist
    const modalProfile=()=>{
        dispatch(modalToggle({ 
            modal_open: true,
            modal_title: "Profile",
            modal_component: "profile",
            modal_size:590,
            modal_type:'',
            modal_data:null,
            modal_action:'profile',
        }))
    }
    const onLogout=()=>{
        dispatch(logout())
    }
    const renderLinkQubisa=(url)=>{
        return `https://www.qubisa.com/auth/sso?token=${token}&callback=${url}`
    }
    const handleClickLink=()=>{
        // dispatch(setPersist({is_auth_qubisa:true}))
    }
    return (
        <div>
            <nav  style={{backgroundColor:'white'}}>
                <div className='navbar'>
                    <div className='div-flex div-align-center'>
                        <div className='navbar-logo'>
                            <a href='https://www.qubisa.com/'><img src={Logo} alt="cdhx logo"/></a>
                        </div>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <h3 className='font-nunito font-bold margin-0' style={{color:'#b90129'}}>Forum</h3>
                    </div>
                    <div className='div-flex div-align-center'>
                        <a onClick={handleClickLink} href={renderLinkQubisa('user/my-course')}><h3 className='kursusqu font-nunito font-bold margin-0 cursor-pointer' style={{marginRight:50}}>KursusQu</h3></a>
                        <div className='div-flex div-align-center'>
                            <a onClick={handleClickLink} href={renderLinkQubisa("cart")}><img src={Trolli} style={{width:18,cursor:'pointer',marginRight:20}}/></a>
                            {/* <a href={`https://www.qubisa.com/auth/sso?token=${token}`}><img src={Trolli} style={{width:18,cursor:'pointer',marginRight:20}}/></a> */}
                            {isMobile?
                            <img onClick={modalProfile} src={profile.profilePic!==''?profile.profilePic:DefaultAva} className='profile-circle'/>
                            :
                            <HtmlTooltip
                                placement="bottom-end"
                                arrow
                                interactive
                                title={
                                <React.Fragment>
                                    <div className='profile-tooltip'>
                                        <a onClick={handleClickLink} href={renderLinkQubisa("user/edit-profile")}><div className='tooltip-item div-flex div-align-center'>
                                            <img src={profile.profilePic!==''?profile.profilePic:DefaultAva} className='profile-circle'/>
                                            &nbsp;&nbsp;&nbsp;&nbsp;
                                            <div className=''>
                                                <p className='font-nunito margin-0' style={{fontSize:16}}>{profile.name}<br/><span style={{fontSize:12}}>{profile.email!==null&&profile.email}</span></p>
                                            </div>
                                        </div></a>
                                        <a onClick={handleClickLink} href={renderLinkQubisa("user/poinqu")}><div className='item-link'>
                                            <p className='font-nunito margin-0' style={{fontSize:16}}>PoinQu</p>
                                        </div></a>
                                        <a onClick={handleClickLink}  href={renderLinkQubisa("order/history")}><div className='item-link'>
                                            <p className='font-nunito margin-0' style={{fontSize:16}}>Riwayat Transaksi</p>
                                        </div></a>
                                        <a onClick={handleClickLink} href={renderLinkQubisa("webinar/history")}><div className='item-link'>
                                            <p className='font-nunito margin-0' style={{fontSize:16}}>Riwayat Webinar</p>
                                        </div></a>
                                        <a href="https://instructor.qubisa.com/course"><div className='item-link'>
                                            <p className='font-nunito margin-0' style={{fontSize:16}}>Jadi Instruktur</p>
                                        </div></a>
                                        <a href="https://www.qubisa.com/support"><div className='item-link'>
                                            <p className='font-nunito margin-0' style={{fontSize:16}}>Bantuan</p>
                                        </div></a>
                                        <a href="#" onClick={onLogout}><div className='item-link'>
                                            <p className='font-nunito margin-0' style={{fontSize:16}}>Keluar</p>
                                            <br/>
                                        </div></a>
                                    </div>
                                   
                                </React.Fragment>
                                }
                            >
                                <img src={profile.profilePic!==''?profile.profilePic:DefaultAva} className='profile-circle'/>
                            </HtmlTooltip>}
                        </div>
                    </div>
                </div>
            </nav>
        </div>
    )
}
export default Navbar